import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { AiOutlineSearch } from "react-icons/ai";


class Navbar extends Component {
  

  toggleOffcanvas() {
   
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }
 sidebar=false
  openSidebar(){
      document.body.classList.toggle('mobile-icon-only')
      document.body.classList.toggle('sidebar-icon-only')
  
  }
  toggleRightSidebar() {
   

    document.querySelector('.right-sidebar').classList.toggle('open');
  }
  render () {
    {document.body.classList.toggle('mobile-icon-only')}
    return (
      <nav className="navbar p-0 fixed-top d-flex flex-row bg-white">
        <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center bg-white">
          <div className="navbar-brand brand-logo-mini bg-white" ><img src={'./logo.svg'} alt="nainji" style={{height:"inherit",width:"80px",padding:"0px"}} /></div>
        </div>
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch" >
          <button className="navbar-toggler align-self-center" type="button" onClick={ () => {this.openSidebar()} } >
            <span className="mdi mdi-menu" style={{fontSize:"25px"}}></span>
          </button>
          <ul className=" w-100">
            <li className="nav-item w-100 ">
              <form className="nav-link mt-2 mt-md-0 d-none d-lg-flex search ">
            {/* <AiOutlineSearch style={{color:"black",height:"200%",marginTop:"15px",backgroundColor:"black"}}></AiOutlineSearch> */}
              
                <input type="text" className="form-control  " size={20} placeholder="Search Something" />
              </form>
            </li>
          </ul>
          <ul className="navbar-nav navbar-nav-right mr-5">
         
            <li className="nav-item d-none d-lg-block">
              <a className="nav-link" href="!#" onClick={event => event.preventDefault()}>
                <i className="mdi mdi-view-grid"></i>
              </a>
            </li>
           
          
            <Dropdown alignRight as="li" className="nav-item">
              <Dropdown.Toggle as="a" className="nav-link cursor-pointer no-caret">
                <div className="navbar-profile">
                  <img className="img-xs rounded-circle" src={require('../../assets/images/faces/face15.jpg')} alt="profile" />
                
                </div>
              </Dropdown.Toggle>

              {/* <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu">
                <h6 className="p-3 mb-0"><Trans>Profile</Trans></h6>
                <Dropdown.Divider />
                <Dropdown.Item href="!#" onClick={evt =>evt.preventDefault()} className="preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-settings text-success"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1"><Trans>Settings</Trans></p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item href="!#" onClick={evt =>evt.preventDefault()}  className="preview-item">
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-logout text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1"><Trans>Log Out</Trans></p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <p className="p-3 mb-0 text-center"><Trans>Advanced settings</Trans></p>
              </Dropdown.Menu> */}
            </Dropdown>
          </ul>
         
        </div>
      </nav>
    );
  }
}

export default Navbar;
